(function () {
'use strict';

angular
    .module('EmployeeEventControllers')
    .directive('employeeEvents', directive);

directive.$inject = ['$filter', 'employeeEventService'];

function directive($filter, employeeEventService) {
    return {
        scope: {
            service: '@'
        },
        restrict: 'AE',
        templateUrl: require('./employeeEvents.tpl.html'),
        controller: ['$scope', 'appParamService', function ($scope, appParamService) {

            appParamService.getAppParam('FromDateWhenArrivalRequest')
                .then(function (appParam) {
                    $scope.fromDateWhenArrivalRequest = appParam.ParamValue;
                });

            $scope.needNewArrivalRequest = function (event) {
                if (!event.IsEmployeeArrival) return false;

                if (_.isUndefined($scope.fromDateWhenArrivalRequest)) return false;

                var creationDate = moment(event.CreationDate);
                if (!(creationDate.isAfter($scope.fromDateWhenArrivalRequest, 'day') ||
                      creationDate.isSame($scope.fromDateWhenArrivalRequest, 'day'))) {
                    return false;
                }

                return event.IsEmployeeArrival && !event.UserAccessRequestID;
            }

            $scope.showHRTransfer = function (empMvt) {
                return empMvt.EventTypeEnum === 13;
            }

            $scope.showAccessCardUpdate = function (empMvt) {
                return empMvt.EventTypeEnum === 22;
            }

            $scope.showPasswordReset = function (empMvt) {
                return empMvt.EventTypeEnum === 23;
            }

            $scope.showAccountChange = function (empMvt) {
                return empMvt.EventTypeEnum === 24;
            }

            $scope.showDefault = function (empMvt) {
                return empMvt.EventTypeEnum !== 13 &&
                       empMvt.EventTypeEnum !== 22 &&
                       empMvt.EventTypeEnum !== 23 &&
                       empMvt.EventTypeEnum !== 24;
            }

            $scope.isDontProcessBeforeGreater = function (dontProcessBefore) {
                return moment(dontProcessBefore).isAfter(Date.now());
            }

            $scope.lastUpdateTimeAgo = function (lastUpdt) {
                if (!_.isUndefined(lastUpdt))
                    return true;
                return false;
            }
        }],
        link: function (scope, element, attrs) {
            var employeeEvents = [];
            var serviceToCall = employeeEventService.GetEventsForEmployee;

            if (scope.service === 'employeeMovement') {
                serviceToCall = employeeEventService.GetEventsForMovementEmployee;
            }

            serviceToCall().then(function (allCombined) {
                employeeEvents = allCombined;
                var begin = ((scope.currentPage.currentPageMvt - 1) * scope.itemsPerPage.itemsPerPageMvt);
                var end = begin + scope.itemsPerPage.itemsPerPageMvt;

                scope.totalItems.totalItemsMvt = employeeEvents.length;
                scope.filteredEvents = employeeEvents.slice(begin, end);
            });

            // watch on next pagination
            scope.search = { Search: null };
            scope.$watch('currentPage.currentPageMvt + itemsPerPage.itemsPerPageMvt', function () {
                scope.filterAndPagination(scope.search.Search);
            });

            // watch on next search
            scope.$watch('search.Search', function (word) {
                scope.filterAndPagination(word);
            });

            // search and update pagination
            scope.filterAndPagination = function (word) {
                var begin = ((scope.currentPage.currentPageMvt - 1) * scope.itemsPerPage.itemsPerPageMvt);
                var end = begin + scope.itemsPerPage.itemsPerPageMvt;

                if (word) {
                    var genericMovementFiltered = $filter('filterByMultiTokens')
                    (employeeEvents, ['EmployeeFirstName', 'EmployeeLastName', 'IamEmployeePosition', 'EmployeeDepartment', 'EventTypeShortDescription'], word);

                    scope.filteredEvents = genericMovementFiltered.slice(begin, end);
                    scope.totalItems.totalItemsMvt = genericMovementFiltered.length;
                } else {
                    scope.filteredEvents = employeeEvents.slice(begin, end);
                    scope.totalItems.totalItemsMvt = employeeEvents.length;
                }
            };

            // Pagination Items
            scope.filteredEvents = [];

            scope.itemsPerPageMvt = 3;
            scope.currentPageMvt = 1;
            scope.maxSize = 5;

            scope.currentPage = { currentPageMvt: scope.currentPageMvt };
            scope.itemsPerPage = { itemsPerPageMvt: scope.itemsPerPageMvt };

            scope.totalItems = { totalItemsMvt: 0 };
        }
    };
}
})();